import { toNumber, type KpiWidget } from '@/lib/cube-report'
import type { ReportRow } from '@/services/cube/report'

import type { ChartResult, KpiResult, ListResult, TableResult } from './types'

/*
 * Sorgu satırlarından serileştirilebilir parça sonucuna saf dönüşümler. Canlı yol
 * ResultSet'i `toRows`/`toTablePage` ile satıra çevirip bunları kullanır; dönem
 * kopyası üretimi (D7) aynı fonksiyonlarla sonucu üretir.
 */

export const kpiFromRows = (
  widget: KpiWidget,
  rows: ReportRow[],
  previousRows?: ReportRow[],
): Pick<KpiResult, 'value' | 'previous'> => ({
  value: toNumber(rows[0]?.[widget.measure]),
  ...(previousRows && { previous: toNumber(previousRows[0]?.[widget.measure]) }),
})

export const tableFromRows = (rows: ReportRow[], totals?: ReportRow[]): TableResult => ({
  rows,
  ...(totals && { totals }),
})

export const listFromPage = (
  page: { items: ReportRow[]; total: number },
  totals?: ReportRow[],
): ListResult => ({ ...page, ...(totals && { totals }) })

/** Tüm satırlar tek sayfa: donmuş liste. */
export const listFromRows = (rows: ReportRow[], totals?: ReportRow[]): ListResult =>
  listFromPage({ items: rows, total: rows.length }, totals)

/** Grafik sonucu zaman kovası başına düz satırlardır; dönüşüm tek yerde dursun diye adlandırıldı. */
export const chartFromRows = (rows: ReportRow[]): ChartResult => rows
